export enum ForgotPasswordField {
  EMAIL = 'email',
}

export interface ForgotPasswordForm {
  [ForgotPasswordField.EMAIL]: string
}

export enum ResetPasswordField {
  PASSWORD = 'password',
  PASSWORD_VALIDATE = 'password_validate',
  TOKEN = 'token',
}

export interface ResetPasswordForm {
  [ResetPasswordField.PASSWORD]: string
  [ResetPasswordField.PASSWORD_VALIDATE]: string
  [ResetPasswordField.TOKEN]: string
}
